<app-create-note [targetType]="targetType"
                 [targetId]="targetId"
                 [noteType]="'text'"
                 (noteAdded)="noteAdded($event)"
                 [shouldAutofocusInput]="shouldAutofocusInput"
                 class="modal__padding mb-0100 d-block">
  <button type="button"
          class="link link--blue link--noline"
          (click)="showNotes = !showNotes"
          [attr.aria-expanded]="showNotes ? 'true' : 'false'"
          *ngIf="notes?.length > 0">
    <span *ngIf="!showNotes">
      <i class="fal fa-chevron-down mr-0050"></i>View Notes</span>
    <span *ngIf="showNotes">
      <i class="fal fa-chevron-up mr-0050"></i>Hide Notes</span>
  </button>
</app-create-note>

<app-view-notes *ngIf="showNotes"
                [notes]="notes"
                [noteCampaignId]="campaignId"
                [targetType]="targetType"
                [targetId]="targetId"></app-view-notes>
